import TmAbortError from '@/core/error/tmAbortError'

export function throwIfAborted(signal?: AbortSignal) {
  if (typeof signal?.throwIfAborted === 'function') {
    signal.throwIfAborted()
  } else if (signal?.aborted) {
    throw new TmAbortError()
  }
}
